import { environment } from '../../environments/environment';

export const api = environment.FLAGSMITH_URL;
export const environmentID = environment.FLAGSMITH_ENVIRONEMT_ID;
